<app-marine-insurance-card
  [cardTitle]="headerText"
  [isDashed]="!isAddedData && isDesktop"
  [isFullHeight]="isDesktop"
  [isShowAddIcon]="!isAddedData && isDesktop"
  [isCanEdit]="isAddedData && isDesktop"
  [isErrored]="isErrored"
  (edit)="edit.emit()"
>
  <ng-container body>
    <div class="marine-insurance-from-to-view-desktop" *ngIf="isDesktop">
      <div *ngIf="!isAddedData">
        <h5 class="marine-insurance-from-to-view-body-text">{{ bodyText | translate }}</h5>

        <p class="marine-insurance-from-to-view-body-hint">{{ bodyHintText | translate }}</p>
      </div>

      <div class="marine-insurance-from-to-view-body-address" *ngIf="isAddedData">
        <address-details [address]="address" [isJoinAllParts]="true"></address-details>
      </div>
    </div>

    <div class="marine-insurance-from-to-view-mobile" *ngIf="!isDesktop">
      <div>
        <h5 class="marine-insurance-from-to-view-body-text">{{ bodyText | translate }}</h5>

        <p class="marine-insurance-from-to-view-body-hint">{{ bodyHintText | translate }}</p>
      </div>

      <app-marine-insurance-from-to-form
        [countryFormControl]="countryFormControl"
        [stateFormControl]="stateFormControl"
        [cityFormControl]="cityFormControl"
        [isHideState]="isHideState"
      ></app-marine-insurance-from-to-form>
    </div>
  </ng-container>
</app-marine-insurance-card>
